<template>
  <v-card class="mx-auto">
    <v-app-bar class="transparent" light flat>
      <v-toolbar-title>
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon> </v-btn
        >Paramètres</v-toolbar-title
      >
    </v-app-bar>
    <!--   <v-container>
      <template>
        <div id="app">
          <vue-dropzone
            ref="imgDropZone"
            id="customdropzone"
            :options="dropzoneOptions"
            @vdropzone-complete="afterComplete"
          ></vue-dropzone>
        </div>
      </template>
    </v-container> -->
    <v-container>
      <v-layout row wrap class="pa-3 project">
        <v-flex>
          <div class="caption grey--text">Nom de l'Application</div>
          <div>{{ parametres.AppName }}</div>
          <div>
            <v-btn
              @click="
                $router.push({
                  name: 'Reglages-UpdateOneparam',
                  params: { settingName: 'AppName', value: parametres.AppName },
                })
              "
              small
              color="primary"
              >Modifier</v-btn
            >
          </div>
        </v-flex>
        <!--  <v-flex>
          <div class="caption grey--text">Langue principale</div>
          <div>{{ parametres.Langage }}</div>
          <div>
            <v-btn
              @click="
                $router.push({
                  name: 'Reglages-UpdateOneparam',
                  params: { settingName: 'Langage', value: parametres.Langage },
                })
              "
              small
              color="primary"
              >Modifier</v-btn
            >
          </div>
        </v-flex> -->
      </v-layout>
    </v-container>
    <v-container>
      <v-layout row wrap class="pa-3 project">
        <v-flex>
          <div class="caption grey--text">Version</div>
          <div>{{ metadata.build }}</div>
          <div class="caption grey--text">Date</div>
          <div>{{ metadata.date }}</div>
         
          <!--    <div>
            <v-btn
              @click="
                $router.push({
                  name: 'Reglages-UpdateOneparam',
                  params: { settingName: 'Version', value: parametres.Version },
                })
              "
              small
              color="primary"
              >Modifier</v-btn
            >
          </div> -->
        </v-flex>
        <!--   <v-flex>
          <div class="caption grey--text">Logo</div>
          <div class="grey ma-6">
            <v-img
              :src="parametres.url_logo"
              alt="url_logo"
              max-height="150"
              max-width="150"
            >
            </v-img>
          </div>
        </v-flex> -->
      </v-layout>
    </v-container>
    
  </v-card>
</template>

<script>
import metadata from "@/metadata.json";
import { mapState, mapActions } from "vuex";
//import vue2Dropzone from "vue2-dropzone";
//import "vue2-dropzone/dist/vue2Dropzone.min.css";
let uuid = require("uuid");

export default {
  components: {
    //vueDropzone: vue2Dropzone,
  },
  data: () => ({
    metadata: {
      time: "",
      build: "",
      version: "",
      date: "",
    },
    parametres: {},
    dropzoneOptions: {
      url: "https://httpbin.org/post",
      thumbnailWidth: 150,
      thumbnailHeight: 150,
      addRemoveLinks: false,
      acceptedFiles: ".jpg, .jpeg, .png",
      dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Glisser les images ici</p>`,
    },
    images: [],
  }),
  created() {
    if (!this.isAdmin) {
      this.$router.push("/");
    }
    this.metadata.build=metadata.build;
    this.metadata.date=metadata.date;


    this.realitimeListenerParametres();
  },
  methods: {
    realitimeListenerParametres() {
      //self.groupe = doc.data();
      let self = this;
      this.$firebase
        .firestore()
        .collection("options")
        .doc("VB08AelKInuKBr3fG6fM")
        .onSnapshot(function (doc) {
          var source = doc.metadata.hasPendingWrites ? "Local" : "Server";
          self.parametres = doc.data();
        });
    },


    ...mapActions({
      userLogOut: "Auth/userSignOut",
    }),
  },
  computed: {
    ...mapState({
      isAdmin: (state) => state.Auth.isAdmin,
    }),
  },
};
</script>
<style></style>
